const getTypeIds = (predicate, types) =>
  Object.keys(types)
    .map(Number)
    .filter(predicate)

export default getTypeIds
